import { Text } from '@chakra-ui/react';

export default function Version() {
  return (
    <Text fonSize="xl">0.0.1</Text>
  );
}